<template>
  <b-card :title="resource.title"
          class="fadeIn animated">
    <p class="card-text text-muted">
      Schnellzugriffscode: {{ resource.quickAccessCode }}
    </p>

    <div class="text-center">
      <audio v-if="resource.fileType === 'audio'" :src="resource.filePath" controls>Audio-Datei herunterladen, um sie abzsupielen.</audio>
    </div>

    <div v-if="resource.fileExtension == 'peertubeId'"  class="peertube-embed-container">
      <iframe
        allowfullscreen
        frameborder="0"
        sandbox="allow-same-origin allow-scripts"
        :src="'https://peertube.giz.berlin/videos/embed/' + resource.peertubeId"
      />
    </div>

    <p class="card-text">
      {{ resource.description }}
    </p>

    <div slot="header">
      <div class="mt-2 float-left" v-if="resource.topic">{{ resource.title }}: Zusatzinhalt {{ resource.topic }}</div>
      <div class="mt-2 float-left" v-else>{{ resource.title }}: Kapitel {{ resource.chapter }}<template v-if="resource.page"> / Seite {{ resource.page }}</template></div>
      <b-button v-if="resource.fileExtension === 'peertubeId'" class="float-right" :href="'https://peertube.giz.berlin/w/' + resource.peertubeId" target="_blank" variant="primary">
        <icon name="link"></icon><span class="d-none d-sm-inline"> Peertube</span>
      </b-button>
      <b-button v-else class="float-right" :href="resource.filePath" target="_blank" variant="primary">
        <icon name="download"></icon><span class="d-none d-sm-inline"> Herunterladen</span>
      </b-button>
    </div>
  </b-card>
</template>

<script>
  import { RESOURCES_LANGUAGES } from '../constants'

  export default {
    name: 'Resource',
    props: {
      resource: {}
    },
    methods: {
      getLanguageString (lang) {
        if (RESOURCES_LANGUAGES[lang] === undefined) {
          throw Error('Unknown lang ' + lang)
        }
        return RESOURCES_LANGUAGES[lang]['name']
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import '../style/bootstrap-component-include';
  @import '~animate.css/animate.css';

  // peertube video
  .peertube-embed-container {
    position: relative;
    padding-bottom: 56.2%; /* ratio 16x9 */
    overflow: hidden;
    width: 100%;
    height: auto;
    margin-bottom: 15px;
  }
  .peertube-embed-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Resource.vue